import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

const KEY = "rp_punch_queue";
export const readQueue = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
export const writeQueue = (q) => localStorage.setItem(KEY, JSON.stringify(q));
export const newClientId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const queuePunch = (body) => { const q = [...readQueue(), body]; writeQueue(q); return q; };

/* Replays queued punches in order; stops on network errors, drops punches the server rejects. */
export async function syncQueue() {
  let q = readQueue();
  if (!q.length || !navigator.onLine) return { synced: 0, remaining: q.length };
  let synced = 0;
  for (const p of [...q]) {
    try { await api.post("/timeclock/self", p); q = q.filter((x) => x.client_id !== p.client_id); writeQueue(q); synced++; }
    catch (e) {
      if (e.response?.status && e.response.status < 500) { q = q.filter((x) => x.client_id !== p.client_id); writeQueue(q); toast.error(`Offline punch rejected: ${formatApiErrorDetail(e.response?.data?.detail)}`); }
      else break;
    }
  }
  if (synced) toast.success(`${synced} offline punch${synced === 1 ? "" : "es"} synced`);
  return { synced, remaining: q.length };
}
